import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
import { debounce } from '../../../helpers'
import useExpandCollapse from '../../../helpers/reactHooks/useExpandCollapse'

const FilterItem = ({
  filter,
  selected,
  onFilterChange
}) => {
  const breakpoint = window.matchMedia('(max-width: 1280px)');
  const { keyword, name } = filter;
  const [display, setDisplay] = useState(!breakpoint.matches);
  const listRef = useRef(null);
  const triggerRef = useRef(null);
  const [selectedCount, setSelectedCount] = useState(0);

  useExpandCollapse(display, triggerRef, listRef);

  const handleSelect = value => {
    const selectedClone = [...selected];

    if (selectedClone.includes(value)) {
      selectedClone.splice(selectedClone.indexOf(value), 1);
    } else {
      selectedClone.push(value);
    }

    const filterItems = {
      name: keyword,
      options: selectedClone
    };

    onFilterChange(filterItems);
  };

  useEffect(() => {
    if (filter) {
      let count = 0;
      filter.options.forEach(opt => {
        if (opt.selected) {
          count += 1;
        }
      })
      setSelectedCount(count)
    }
  }, [filter]);

  useEffect(() => {
    const listener = () => {
      if (breakpoint.matches) {
        setDisplay(false);
      } else {
        setDisplay(true);
      }
    };

    debounce(window.addEventListener('resize', listener), 500);
    return () => window.removeEventListener('resize', listener);
  }, []);

  return (
    <div className="accordion__item">
      <button
        className="accordion__item-trigger"
        aria-expanded="false"
        aria-controls={`${name}List`}
        ref={triggerRef}
        onClick={() => setDisplay(!display)}
      >
        <div className="small-card-title">
          {name}
          {selectedCount > 0 && (<span> ({selectedCount})</span>)}
        </div>
        <span className="accordion__item-icon cta-decorator-v2">
          <svg viewBox="0 0 64 64">
            <use xlinkHref={display ? '#minus-icon-rebrand' : '#plus-icon-rebrand'}/>
          </svg>
        </span>
      </button>

      <div
        role="region"
        id={`${name}List`}
        className="accordion__item-content"
        aria-labelledby={`${name}List`}
        aria-hidden="true"
        data-list-from={keyword}
        ref={listRef}
      >
        <div className="accordion__item-inner">
          {filter.options.map((option, i) => (
            <div key={i} className="filter-item__option">
              <label>
                <input
                  type="checkbox"
                  name={option.name}
                  id={option.name}
                  checked={option.selected || selected.includes(option.value)}
                  onChange={() => handleSelect(option.name)}
                />
                <span className="checkmark"></span>
                <span>{option.name}</span>
                <span>{option.matches}</span>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

FilterItem.propTypes = {
  filter: PropTypes.object,
  selected: PropTypes.array,
  onFilterChange: PropTypes.func
};

export default FilterItem;
